'use strict';

angular.module('shiftTraderApp')
  .controller('RequestDayOffModalCtrl', function($scope, $uibModalInstance, $uibModal, SAErrorHandler, params,
                                                 ViewDayOffModalService, AvailabilityRules, Session, TimeService,
                                                 WorkPeriods, DaysOffStore, DayOffLimitStore, UserPermissionsService,
                                                 OverrideTokens, toastr) {
    $scope.me = params.me;
    $scope.user = params.user;
    $scope.startOfWeekDay = Session.getStartOfWeekDay();
    $scope.dateToday = TimeService.getNowInStoreTime().toDate();
    $scope.workDayStartHour = Session.getWorkDayStartHour();

    var orgId = $scope.user.memberships[0].organization ? $scope.user.memberships[0].organization.id : $scope.user.memberships[0].organization_id;
    $scope.org = null;
    Session.getCurrentOrg()
      .then(function(org) {
        $scope.org = org;
      });

    $scope.newBlackoutDateData = {
      start_date: moment.utc().tz(Session.getTimezone()).hours(0).minutes(0).seconds(0).milliseconds(0).add(2, 'weeks').toDate(),
      end_date: moment.utc().tz(Session.getTimezone()).hours(0).minutes(0).seconds(0).milliseconds(0).add(2, 'weeks').toDate(),
      start_time_raw: moment().week(26).minutes(0).hours($scope.workDayStartHour).milliseconds(0).seconds(0).toDate(),
      end_time_raw: moment().week(26).minutes(0).hours($scope.workDayStartHour).milliseconds(0).seconds(0).toDate()
    };

    $scope.newBlackoutDateData.end_date = moment.utc().tz(Session.getTimezone()).hours(0).minutes(0).seconds(0).milliseconds(0).add(2, 'weeks').add(1, 'day').toDate();

    var d = TimeService.getBeginningOfDayFromDate(moment()), dd = TimeService.getBeginningOfDayFromDate(moment());
    $scope.requestDaysAdv = $scope.user.memberships[0].organization.organization_config.num_days_request_advance;
    $scope.cannotRequestTwix = ($scope.requestDaysAdv) ? d.twix(dd.add($scope.requestDaysAdv + 1, 'days')) : null;

    $scope.isSuperUser = false;
    $scope.overrideToken = null;
    OverrideTokens.getOne({ user_id: $scope.user.id, organization_id: orgId, token_type: 'DayOff' })
      .then(function(token) {
        $scope.overrideToken = token;
      }, function(response) {
        console.log('Failed to load override token', response);
      });


    $scope.datePickerOptions = {
      startingDay: $scope.startOfWeekDay,
      minDate: $scope.dateToday,
      showWeeks: false
    };

    $scope.datepickers = {
      startDateOpened: false,
      endDateOpened: false
    };

    $scope.state = {
      dayoffRequestType: 1,
      requestInProgress: false,
      checkingCurrentSchedule: false,
      scheduleOverlapsWithRequest: false,
      notInAdvanceEnough: false,
      showHides: {
        endDate: false,
        startTime: false,
        endTime: false
      },
      checksFinished: false,
      limitAckCheckbox: false,
      rawPermissions: null,
      derivedPermissions: null
    };

    var permissionsToLookUp = [
      'days_off.request_for_other',
      'days_off.request_for_self',
      'days_off.create_override'
    ];

    function processRawPermissions() {
      var rawPerms = $scope.state.rawPermissions;

      $scope.state.derivedPermissions = {
        canRequestForOthers: rawPerms['days_off.request_for_other']
      };
    }

    UserPermissionsService.getCanDict(permissionsToLookUp, orgId)
      .then(function(dikt) {
        $scope.state.rawPermissions = dikt;

        $scope.isSuperUser = dikt['days_off.create_override'];

        processRawPermissions();
      });

    function areRawDatesValid() {
      return !lodash.isNull($scope.newBlackoutDateData.start_time_raw) && !lodash.isNull($scope.newBlackoutDateData.end_time_raw);
    }

    $scope.checks = {
      overlappingWorkPeriods: {
        check_run: false,
        _collapsed: true
      },
      overlappingDayOffRequests: {
        check_run: false,
        _collapsed: true
      },
      limitChecks: {
        check_run: false,
        _collapsed: true,
        num_entries: 0
      }
    };

    function updateChecksFinished() {
      $scope.state.checksFinished = lodash.every($scope.checks, function(obj) {
        return obj.check_run;
      });
    }

    var createdRules = [];

    $scope.$watch('state.dayoffRequestType', function(val) {

      if (val == 1) {
        $scope.state.showHides = {
          endDate: false,
          startTime: false,
          endTime: false
        };

        $scope.newBlackoutDateData.end_date = moment($scope.newBlackoutDateData.start_date).add(1, 'days').toDate();
        $scope.newBlackoutDateData.start_time_raw = moment().week(26).minutes(0).hours($scope.workDayStartHour).milliseconds(0).seconds(0).toDate();
        $scope.newBlackoutDateData.end_time_raw = moment().week(26).minutes(0).hours($scope.workDayStartHour).milliseconds(0).seconds(0).toDate();
      } else if (val == 2) {
        $scope.state.showHides = {
          endDate: false,
          startTime: true,
          endTime: true
        };

        $scope.newBlackoutDateData.end_date =  moment($scope.newBlackoutDateData.start_date).toDate();
        $scope.newBlackoutDateData.start_time_raw = moment($scope.newBlackoutDateData.start_time_raw).hours($scope.workDayStartHour).toDate();
        $scope.newBlackoutDateData.end_time_raw = moment($scope.newBlackoutDateData.start_time_raw).hours($scope.workDayStartHour + 8).toDate();
      } else if (val == 3) {
        $scope.state.showHides = {
          endDate: true,
          startTime: false,
          endTime: false
        };

        $scope.newBlackoutDateData.end_date = moment($scope.newBlackoutDateData.start_date).add(2, 'days').toDate();
        $scope.newBlackoutDateData.start_time_raw = moment().week(26).minutes(0).hours($scope.workDayStartHour).milliseconds(0).seconds(0).toDate();
        $scope.newBlackoutDateData.end_time_raw = moment().week(26).minutes(0).hours($scope.workDayStartHour).milliseconds(0).seconds(0).toDate();
      } else if (val == 4) {
        $scope.state.showHides = {
          endDate: true,
          startTime: true,
          endTime: true
        };
      }
    });


    $scope.$watch('newBlackoutDateData.start_date', function(start_date) {
      if ($scope.state.dayoffRequestType == 1) {
        $scope.newBlackoutDateData.end_date = moment(start_date).add(1, 'days').toDate();
      }

      if ($scope.state.dayoffRequestType == 2) {
        $scope.newBlackoutDateData.end_date = moment(start_date).toDate();
      }

      if ($scope.state.dayoffRequestType == 3 || $scope.state.dayoffRequestType == 4) {
        if (moment($scope.newBlackoutDateData.start_date).dayOfYear() >= moment($scope.newBlackoutDateData.end_date).dayOfYear()) {
          $scope.newBlackoutDateData.end_date = moment($scope.newBlackoutDateData.start_date).add(2, 'days').toDate();
        }
      }
    });

    function onDateRangeChange() {
      setupWeekCalendar();
      checkCurrentSchedule();
    }

    function checkExistingDayOffRequests() {
      var currentRange = getCurrentRange();

      var existingRules = lodash.filter($scope.user.time_off_rules, function(r) {
        return r._type === 'single' && r.active;// && r.approved_by !== null;
      });

      var requests = lodash.filter(existingRules, function(rule) {
        return rule.range_twix.overlaps(currentRange) && Math.abs(rule.range_twix.intersection(currentRange).length('minutes')) > 0;
      });


      $scope.checks.overlappingDayOffRequests = {
        num_entries: requests.length,
        entries: requests,
        check_run: true
      };
      updateChecksFinished();
    }

    function calcDaysInAdvance() {
      var twx = getCurrentRange();
      var startOfToday = TimeService.getBeginningOfDayFromDate(TimeService.getNowInStoreTime());

      $scope.state.daysInAdvance = startOfToday.twix(twx.start).length('days');
      $scope.state.requestLongerThanThirty = twx.length('days') > 30;
    }

    var debouncedOnDateRangeChange = _.debounce(onDateRangeChange, 500);

    $scope.$watch('newBlackoutDateData', function() {
      console.log('$WATCH newBlackoutDateData');

      if (areRawDatesValid()) {
        debouncedOnDateRangeChange();
        calcDaysInAdvance();
        checkExistingDayOffRequests();
      }

    }, true);

    var calculateTimes = function() {
      var start_minutes, end_minutes, hours, minutes;

      hours = $scope.newBlackoutDateData.start_time_raw.getHours();
      minutes = $scope.newBlackoutDateData.start_time_raw.getMinutes();
      start_minutes = hours * 60 + minutes;

      hours = $scope.newBlackoutDateData.end_time_raw.getHours();
      minutes = $scope.newBlackoutDateData.end_time_raw.getMinutes();

      end_minutes = hours * 60 + minutes;
      return {
        start_time_minutes: start_minutes,
        end_time_minutes: end_minutes
      };
    };


    $scope.openStartDate = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      if ($scope.datepickers.startDateOpened === true) {
        $scope.datepickers.startDateOpened = false;
      } else {
        $scope.datepickers.startDateOpened = true;
      }
    };

    $scope.openEndDate = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      if ($scope.datepickers.endDateOpened === true) {
        $scope.datepickers.endDateOpened = false;
      } else {
        $scope.datepickers.endDateOpened = true;
      }
    };

    var getCurrentRange = function() {
      var processedMinutes = calculateTimes();
      var start = TimeService.getBeginningOfDayFromDate(moment($scope.newBlackoutDateData.start_date));
      start = start.minutes(processedMinutes.start_time_minutes);
      var end = TimeService.getBeginningOfDayFromDate(moment($scope.newBlackoutDateData.end_date));
      end = end.minutes(processedMinutes.end_time_minutes);

      if ($scope.state.dayoffRequestType == 3) {
        end = end.add(1, 'days');
      }

      return start.twix(end);
    };

    var getAvailRuleDateText = function(rule) {
      if ($scope.state.dayoffRequestType == 1) {
        return rule.start.format('MMMM Do');
      } else if ($scope.state.dayoffRequestType == 3) {
        return rule.start.format('MMM Do') + ' through ' + moment(rule.end).subtract(12, 'hours').format('MMM Do');
      } else {
        // Line below gives EXACT request dates, hours (but, the end date won't match the End Date above)
        return rule.$minimalIntervalTimeFormat();
      }
    };

    var lastValidatedRange;
    $scope.validateDate = function() {
      if (!areRawDatesValid()) {
        $scope.state.dateRangeIsValid = false;
        $scope.requestBlackoutText = 'Day off request times are invalid';
        return false;
      }

      var now = moment.utc().unix();
      var processedMinutes = calculateTimes();
      var currentRange = getCurrentRange();

      if (!lodash.isUndefined(lastValidatedRange) && !lastValidatedRange.equals(currentRange)) {
        $scope.overlappingWorkPeriods = [];
      }
      lastValidatedRange = currentRange;

      var data = {
        user_id: $scope.user.id,
        organization_id: orgId,
        recurring: false,
        repeats_on_weekly: 0,
        avail: false,
        start_date: currentRange.start.format('YYYY-MM-DD'),
        start_time_minutes: processedMinutes.start_time_minutes,
        end_time_minutes: processedMinutes.end_time_minutes,
        end_date: currentRange.end.format('YYYY-MM-DD'),
        day_of_week: currentRange.start.day(),
        comment: $scope.newBlackoutDateData.comment
      };

      var newDayOff = AvailabilityRules.initWithData(data);
      $scope.submitButtonCounts = newDayOff.$getNumberOfFullAndPartialDays();

      $scope.currentDayoffAsText = getAvailRuleDateText(newDayOff);

      if ($scope.newBlackoutDateData.start_date === '') {
        // if start_date is not set, invalidate
        $scope.requestBlackoutText = 'Select A Date Range';
        $scope.state.dateRangeIsValid = false;
        return false;
      } else {
        var start_date = currentRange.start.unix();
        // verify that the start_date is before now, otherwise invalidate
        if (start_date < now) {
          $scope.requestBlackoutText = 'Select A Future Day';
          $scope.state.dateRangeIsValid = false;
          return false;
        }

        if (start_date >= currentRange.end.unix()) {
          $scope.requestBlackoutText = 'End Date must be the same as or after Start Date';
          $scope.state.dateRangeIsValid = false;
          return false;
        }

        var latestAllowedStartDate;
        if ($scope.user.$curMemb().organization.organization_config.dayoff_max_days_from_now === 0 || $scope.state.derivedPermissions.canRequestForOthers) {
          latestAllowedStartDate = moment().add(5, 'years');
        } else {
          latestAllowedStartDate = moment().add($scope.user.$curMemb().organization.organization_config.dayoff_max_days_from_now, 'days');
        }
        if (start_date > latestAllowedStartDate.unix()) {
          $scope.requestBlackoutText = 'You are not allowed to request days off more than ' + $scope.user.$curMemb().organization.organization_config.dayoff_max_days_from_now + ' days in the future. Your request has to start on or before ' + latestAllowedStartDate.subtract(1, 'day').format('MMM D, YYYY') + '. Ask your manager to put in this request.';
          $scope.state.dateRangeIsValid = false;
          return false;
        }

        if ($scope.checks.overlappingWorkPeriods.num_entries > 0 && !lodash.isNull($scope.state.derivedPermissions) && !$scope.state.derivedPermissions.canRequestForOthers) {
          $scope.requestBlackoutText = 'You must give or trade away your overlapping shifts before making this request.';
          return false;
        }
      }

      $scope.requestBlackoutText = '';
      $scope.state.dateRangeIsValid = true;
      return true;
    };


    $scope.createDayOff = function() {
      if (!$scope.state.requestInProgress) {
        $scope.state.requestInProgress = true;
        var processedMinutes = calculateTimes();

        var theTwix = getCurrentRange();
        var start_date = theTwix.start;
        var end_date = theTwix.end;

        var data = {
          user_id: $scope.user.id,
          organization_id: orgId,
          recurring: false,
          repeats_on_weekly: 0,
          avail: false,
          start_date: start_date.format('YYYY-MM-DD'),
          start_time_minutes: processedMinutes.start_time_minutes,
          end_date: end_date.format('YYYY-MM-DD'),
          end_time_minutes: processedMinutes.end_time_minutes,
          day_of_week: start_date.day(),
          comment: $scope.newBlackoutDateData.comment
        };

        // add limitCheck data to the request (ability to easily see what the employee was shown

        //gather all of the days from the weeks
        var days = lodash.filter(lodash.flattenDeep(lodash.map($scope.dataByWeek, 'days')), function(day) {
          return !!day.limitPosition
        });

        data.metadata = {
          limitChecks: lodash.map(days, function(day) {
            return {
              position: day.limitPosition,
              day_off_limit_id: day.limitRecord ? day.limitRecord.id : null,
              limit: day.limitRecord ? day.limitRecord.limit : null,
              date: day.range_twix.start.format('YYYY-MM-DD')
            };
          })
        };

        // allow admins to always add day off, regardless of whether it overlaps.
        if ((!lodash.isNull($scope.state.derivedPermissions) && $scope.state.derivedPermissions.canRequestForOthers) || $scope.checks.overlappingWorkPeriods.num_entries === 0) {
          AvailabilityRules.createRule(data)
            .then(function(newRule) {
              createdRules.push(newRule);
              $scope.user.time_off_rules.push(newRule);
              toastr.success(getAvailRuleDateText(newRule) + ' Requested Off', 'Success');
              $scope.newBlackoutDateData.start_date = moment.utc($scope.newBlackoutDateData.start_date).add(1, 'days').format('YYYY-MM-DD');
              $scope.newBlackoutDateData.comment = '';
              $scope.state.requestInProgress = false;
              $scope.state.checkingCurrentSchedule = false;

              $scope.close(createdRules);
            }, function(response) {
              console.log('createBlackoutDate had an error');
              console.log(response);
              SAErrorHandler.processError(response);
              $scope.state.requestInProgress = false;
            });
        }
      }
    };

    $scope.close = function() {
      $uibModalInstance.close(createdRules);
    };

    function addLimitCheckEntry(position, dtTwix, limitRecord) {
      if (!$scope.checks.limitChecks.entries) {
        $scope.checks.limitChecks.entries = [];
        $scope.checks.limitChecks.num_entries = 0;
      }

      $scope.checks.limitChecks.entries.push({
        position: position,
        dtTwix: dtTwix,
        limitRecord: limitRecord,
        message: limitRecord.$getLatestMessage()
      });

      $scope.checks.limitChecks.num_entries = $scope.checks.limitChecks.entries.length;
    }

    function calcRequestPositionRelativeToLimit(weekIdx, dayIdx) {
      var dtTwix = $scope.dataByWeek[weekIdx].days[dayIdx].range_twix;

      DaysOffStore.getDaysOffIntersectingDate(dtTwix.start)
        .then(function(daysOff) {
          var filteredSortedDaysOff = lodash.sortBy(lodash.filter(daysOff, function(dayOff) {
            return dayOff.$isPending() || dayOff.$isApproved();
          }), function(dayOff) {
            return dayOff._created_at_unix;
          });

          var position = filteredSortedDaysOff.length + 1;
          var cls = 'no-limit';
          $scope.dataByWeek[weekIdx].days[dayIdx].limitPosition = position;

          DayOffLimitStore.getLimitForDate(dtTwix.start)
            .then(function(limitRecord) {
              if (!lodash.isNull(limitRecord)) {
                $scope.dataByWeek[weekIdx].days[dayIdx].limitRecord = limitRecord;

                if (position > limitRecord.limit) {
                  cls = 'over-limit';
                  addLimitCheckEntry(position, dtTwix, limitRecord);
                } else if (position < limitRecord.limit) {
                  cls = 'under-limit';
                } else if (position === limitRecord.limit) {
                  cls = 'at-limit';
                }

                if (cls !== '') {
                  $scope.dataByWeek[weekIdx].days[dayIdx]._cssClasses[cls] = true;
                }
              }

              $scope.checks.limitChecks.check_run = true;
              updateChecksFinished();
            }, function() {
              console.log('limit issue');
            });


        }, function() {
          console.log('issue pulling daysOff');
        });

    }


    function checkCurrentSchedule() {
      $scope.state.checkingCurrentSchedule = true;

      var requestRange = getCurrentRange();
      var start_date = requestRange.start;
      var end_date = requestRange.end;

      WorkPeriods.getByUserId($scope.user.id, {
        start_time: moment(start_date).subtract(1, 'days').format('YYYY-MM-DD'),
        end_time: moment(end_date).add(1, 'days').format('YYYY-MM-DD')
      }).then(function(workPeriods) {
        $scope.overlappingWorkPeriods = lodash.filter(workPeriods, function(wp) {
          return wp.range_twix.overlaps(requestRange) && Math.abs(wp.range_twix.intersection(requestRange).length('minutes')) > 0;
        });

        $scope.checks.overlappingWorkPeriods = {
          num_entries: $scope.overlappingWorkPeriods.length,
          entries: $scope.overlappingWorkPeriods,
          check_run: true
        };

        updateChecksFinished();

        $scope.state.checkingCurrentSchedule = false;

      }, function() {

      });
    }


    function setupWeekCalendar() {
      //console.log('setupWeekCalendar');
      var dayOffRequestTwix = getCurrentRange();

      //console.log('dayOffRequestTwix', dayOffRequestTwix.format());

      var currentDate = moment(dayOffRequestTwix.start);

      $scope.state.notInAdvanceEnough = ($scope.requestDaysAdv > 0) && $scope.cannotRequestTwix.overlaps(dayOffRequestTwix);

      var firstWeek = TimeService.getWeekTwixFromMoment(moment(currentDate).startOf('week'));
      var startOfMonth = moment((TimeService.getWeekTwixFromMoment(moment(currentDate).startOf('month'))).end).startOf('month');

      $scope.weeks = lodash.map([0,1,2,3,4], function(x) {
        return (moment(firstWeek.start).add(x, 'weeks')).twix(moment(firstWeek.start).add(x+1, 'weeks'));
      });

      $scope.datesByWeek = lodash.map($scope.weeks, function(week) {
        return lodash.map(lodash.range(7), function(dayNum) {
          return moment(week.start).add(dayNum, 'days').twix(moment(week.start).add(dayNum + 1, 'days'));
        });
      });

      var isMultiDayRequest = dayOffRequestTwix.start.dayOfYear() !== dayOffRequestTwix.end.dayOfYear();
      var relativePositionLimitAnalysisToExec = [];

      var dayStartHour = Session.getWorkDayStartHour();

      $scope.dataByWeek = lodash.map($scope.datesByWeek, function (weekOfDays, weekIdx) {
        return {
          week: $scope.weeks[weekIdx],
          days: lodash.map(weekOfDays, function (dt, dayIdx) {
            // return ._cssClasses;
            // need to know what is previous or next month
            // need to know if this day is affected by the request

            var dtIntersection = dt.overlaps(dayOffRequestTwix) ? Math.abs(dayOffRequestTwix.intersection(dt).length('minutes')) : 0;

            var temp = {
              range_twix: dt,
              _cssClasses: {
                cannotRequest: $scope.cannotRequestTwix && $scope.cannotRequestTwix.overlaps(dt),
                previous_month: dt.start.isBefore(startOfMonth),
                next_month: dt.start.isAfter(moment(startOfMonth).endOf('month')),
                request_overlaps_day: (!isMultiDayRequest && dtIntersection > 0) || (isMultiDayRequest && dtIntersection > ( dayStartHour * 60)), // if this is a single day request OR if the request overlaps the day by MORE than dayStartHour hrs, then show it.
                complete_overlap: dt.overlaps(dayOffRequestTwix) &&
                (dayOffRequestTwix.start.isBefore(dt.start) || dayOffRequestTwix.start.isSame(dt.start)) &&
                (dayOffRequestTwix.end.isAfter(dt.end) || dayOffRequestTwix.end.isSame(dt.end))
              }
            };

            if (temp._cssClasses.request_overlaps_day || temp._cssClasses.complete_overlap) {
              // pull up the limit on that day AND all DaysOff records on that day to calculate where this request is on each day
              relativePositionLimitAnalysisToExec.push([weekIdx, dayIdx]);
            }

            return temp;
          })
        };
      });

      lodash.each(relativePositionLimitAnalysisToExec, function(x) {
        calcRequestPositionRelativeToLimit(x[0], x[1]);
      });
    }

    setupWeekCalendar();


    $scope.openDayOffViewModal = function(dayOff) {
      ViewDayOffModalService.openViewDayOffModal(dayOff.id, function(statusCode, result) {
        // console.log(statusCode, result);
        if (statusCode > 0) {
          var idx = lodash.findIndex($scope.user.time_off_rules, {id: result.id});

          if (idx > -1) {
            $scope.user.time_off_rules[idx] = result;
            checkExistingDayOffRequests();
          }
        } else {

        }
      })
    };

    $scope.openPolicyModal = function() {
      var modalInstance = $uibModal.open({
        size: 'policy',
        templateUrl: 'views/dayOffPolicyModal.html',
        controller: 'dayOffPolicyModal',
        controllerAs: 'vm',
        resolve: {
          params: function() {
            return {
              me: $scope.me,
              org: $scope.org,
              canEdit: false
            };
          }
        }
      });

    };

  });
